import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HrMasterDataRecordHistoryComponent } from './hr-master-data-record-history.component';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { UiPageTitleModule, UiUtilModule } from 'ui-shared';

@NgModule({
    declarations: [HrMasterDataRecordHistoryComponent],
    imports: [CommonModule, TranslateModule, PrimeTemplate, TableModule, UiUtilModule, UiPageTitleModule],
    exports: [HrMasterDataRecordHistoryComponent],
})
export class HrMasterDataRecordHistoryModule {}
